<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" @getOtherFormVal="getOtherFormVal" />
      <Insurance ref="insurance" @getOtherFormVal="getOtherFormVal" />
      <Receipt ref="receipt" />
      <Other ref="other" @getOtherFormVal="getOtherFormVal" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import Receipt from './receipt';
import Insurance from './insurance';
import Other from './other';
import SubBtnBox from 'components/subBtnBox';
import {
  borrowEdit,
  borrowDetail,
} from 'api/cost';
import {
  getEnumList,
} from 'api';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    Insurance,
    Receipt,
    Other,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/cost/borrow/worker/edit',
      formComponents: ['baseForm', 'insurance', 'receipt', 'other'],
    };
  },
  computed: {
    detailParams () {
      return {
        LId: this.$route.query.id,
      };
    },
  },
  methods: {
    detailApi: borrowDetail,
    editApi: borrowEdit,
    async getOtherFormVal ({ from, tar }) {
      const tarFormData = await this.$refs[tar].cacheData();
      this.$refs[from].receiveData(tar, tarFormData);
    },
  },
  async mounted () {
    const enumsList = await getEnumList({
      codeType: 'LOAN_SUBJECT,IS_NEED_BILL_OA,LOAN_ACCIDENT_TYPE,LOAN_ACCIDENT_REASON,LOAN_DUTY_DIVIDE,LOAN_ACCIDENT_DRIVER',
    });
    this.$nextTick(() => {
      this.$refs.baseForm.setList(enumsList);
      this.$refs.insurance.setList(enumsList);
    });
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
